<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown no-flip name="tab-items">
                <template slot="button-content">
                    <i class="cus-page-white-text"></i>
                    Items
                </template>
                <div>
                    <b-dropdown-item @click="displayList()">
                        <i class="cus-page-white-text"></i>
                        View Items
                    </b-dropdown-item>
                </div>

                <li class="dropdown-divider" v-if="canAddNew"></li>

                <b-dropdown-item
                    v-if="canAddNew"
                    @click.prevent="addEstimateItem()"
                >
                    <i class="cus-add"></i>
                    New Item
                </b-dropdown-item>
                <b-dropdown-item v-if="canAddNew" @click="createBundle">
                    <i class="cus-add"></i>
                    New Bundle
                </b-dropdown-item>
                <li
                    v-if="
                        !estimate.isapprove &&
                        (estimate.client ? isBusinessActorActive : true) &&
                        (_hasAccess('billing.estimate.item.delete') ||
                            _hasAccess('billing.estimate.item.decline'))
                    "
                    class="dropdown-divider"
                ></li>
                <b-dropdown-item
                    v-if="
                        !estimate.isapprove &&
                        (estimate.client ? isBusinessActorActive : true) &&
                        _hasAccess('billing.estimate.item.decline')
                    "
                    @click="declineMultiple(true)"
                >
                    <i class="cus-page-delete"></i>
                    Decline Items
                </b-dropdown-item>
                <b-dropdown-item
                    v-if="
                        !estimate.isapprove &&
                        (estimate.client ? isBusinessActorActive : true) &&
                        _hasAccess('billing.estimate.item.delete')
                    "
                    @click="deleteMultiple(true)"
                >
                    <i class="cus-delete"></i>
                    Delete Items
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <template v-if="isDeclineMultiple || isDeleteMultiple">
            <div
                class="pl-2 py-2"
                :class="isSelected ? 'cursor-pointer' : null"
            >
                <b v-if="isSelected" @click="bulkRemove()" class="text-primary"
                    >{{
                        `${
                            declineOrDelete.charAt(0).toUpperCase() +
                            String(declineOrDelete).slice(1)
                        } Selected`
                    }}
                </b>
                <span v-else class="text-muted cursor-not-allowed">{{
                    `${
                        declineOrDelete.charAt(0).toUpperCase() +
                        String(declineOrDelete).slice(1)
                    } Selected`
                }}</span>
                |
                <b
                    @click="
                        isDeclineMultiple
                            ? declineMultiple(false)
                            : deleteMultiple(false)
                    "
                    class="text-primary cursor-pointer"
                    >Cancel
                </b>
                <span
                    v-if="isSelected"
                    class="text-muted text-center mb-0 p-2 mx-2"
                >
                    (
                    {{ selectLength }}
                    {{ selectLength == 1 ? "item" : "items" }} selected )
                </span>
            </div>
        </template>
        <b-card-text>
            <item-list
                :estimate="estimate"
                ref="itemList"
                v-on="$listeners"
                :key="keyview"
                :isBulkRemove="isDeclineMultiple || isDeleteMultiple"
                :bulkRemoveType="declineOrDelete"
                @is-item-selected="isItemSelect"
                @reset-bulk-remove="resetBulkRemove"
            />
        </b-card-text>
    </b-tab>
</template>

<script>
import ItemList from "@/components/estimate-item/item-list";

export default {
    components: {
        ItemList
    },
    props: {
        estimate: {
            type: Object,
            required: true
        }
    },
    computed: {
        isBusinessActorActive() {
            return (
                this.estimate.client &&
                this.estimate.client.single_business_actor &&
                this.estimate.client.single_business_actor.isactive
            );
        },
        canAddNew() {
            return (
                this._hasAccess("billing.estimate.item.create") &&
                !this.estimate.isapprove &&
                (this.estimate.client ? this.isBusinessActorActive : true)
            );
        },
        declineOrDelete() {
            return this.isDeclineMultiple
                ? "decline"
                : this.isDeleteMultiple
                ? "delete"
                : null;
        }
    },
    data() {
        return {
            keyview: 0,
            isDeclineMultiple: false,
            isDeleteMultiple: false,
            isSelected: false,
            selectLength: 0
        };
    },
    methods: {
        displayList() {
            this.keyview += 1;
        },
        reloadItem() {
            // Render getItems when the itemList already rendered
            if (this.$refs.itemList) {
                this.$refs.itemList.getItems();
            }
        },
        createBundle() {
            this.$emit("create-bundle");
        },
        async addEstimateItem() {
            this.$emit("add-estimate-item");
        },
        reloadEstimateDetails() {
            this.$emit("reload-estimate-details");
        },
        resetBulkRemove() {
            this.isDeclineMultiple = false;
            this.isDeleteMultiple = false;
        },
        declineMultiple(val) {
            this.isDeclineMultiple = val;
            if (val) {
                this.isDeleteMultiple = false;
                this.$refs.itemList.checkboxChange();
            }
        },
        deleteMultiple(val) {
            this.isDeleteMultiple = val;
            if (val) {
                this.isDeclineMultiple = false;
                this.$refs.itemList.checkboxChange();
            }
        },
        bulkRemove() {
            this.isDeclineMultiple
                ? this.$refs.itemList.bulkDecline()
                : this.$refs.itemList.bulkDelete();
        },
        isItemSelect(val) {
            this.selectLength = val;
            this.isSelected = val > 0;
        }
    }
};
</script>
